module.exports = __webpack_public_path__ + "img/l-b.aa942e50.png";